// // //-------------------------------------All driver assign vehicle display-------------------------------------
// // import {
// //     FETCH_BOOKING_REQUESTS_REQUEST,
// //     FETCH_BOOKING_REQUESTS_SUCCESS,
// //     FETCH_BOOKING_REQUESTS_FAIL,
// //     ADMIN_FIND_NEAREST_DRIVER_REQUEST,
// //     ADMIN_FIND_NEAREST_DRIVER_SUCCESS,
// //     ADMIN_FIND_NEAREST_DRIVER_FAIL,
// //     ADMIN_ACCEPT_BOOKING_REQUEST,
// //     ADMIN_ACCEPT_BOOKING_SUCCESS,
// //     ADMIN_ACCEPT_BOOKING_FAIL,
// //     ADMIN_CHECK_CONFLICT_REQUEST,
// //     ADMIN_CHECK_CONFLICT_SUCCESS,
// //     ADMIN_CHECK_CONFLICT_FAIL,
// //     RESET_ADMIN_BOOKING_REQUEST,
// // } from '../constants/AdminBookingRequestConstants'

// // import AdminBookingRequestService from '../services/AdminBookingRequestService'

// // // ─── haversine (same as ScheduleBookingAction) ────────────────────────────────
// // const haversineKm = (lat1, lon1, lat2, lon2) => {
// //     const R = 6371
// //     const toRad = (v) => (v * Math.PI) / 180
// //     const dLat = toRad(lat2 - lat1)
// //     const dLon = toRad(lon2 - lon1)
// //     const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2
// //     return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
// // }

// // // ─── Fetch all pending schedule booking requests ──────────────────────────────
// // export const FetchBookingRequests = () => async (dispatch) => {
// //     dispatch({ type: FETCH_BOOKING_REQUESTS_REQUEST })
// //     try {
// //         const res  = await AdminBookingRequestService.GetBookingRequestDetails()
// //         const data = res.data?.resultSet || res.data || []
// //         const list = Array.isArray(data) ? data : []
// //         dispatch({ type: FETCH_BOOKING_REQUESTS_SUCCESS, payload: list })
// //         return list
// //     } catch (error) {
// //         dispatch({ type: FETCH_BOOKING_REQUESTS_FAIL, payload: error?.response?.data?.message || error.message })
// //         throw error
// //     }
// // }

// // // ─── Find nearest + AVAILABLE vehicle ─────────────────────────────────────
// // export const AdminFindNearestDriver = (booking) => async (dispatch) => {
// //     dispatch({ type: ADMIN_FIND_NEAREST_DRIVER_REQUEST })
// //     try {
// //         const vRes     = await AdminBookingRequestService.GetRequestVehicleDetails()
// //         const vehicles = vRes.data?.resultSet || vRes.data || []

// //         if (!Array.isArray(vehicles) || !vehicles.length)
// //             throw new Error('No vehicles returned from GetRequestVehicleDetails')

// //         const toLat = parseFloat(booking.elatitude)
// //         const toLon = parseFloat(booking.elongitude)

// //         if (isNaN(toLat) || isNaN(toLon))
// //             throw new Error(`Booking ${booking.reqId} has no valid location`)

// //         const bookingTonnage = String(booking.tonnage || '').trim().toUpperCase()

// //         const weightMatched = vehicles.filter((v) =>
// //             String(v.weightCat || '').trim().toUpperCase() === bookingTonnage &&
// //             v.driverSno && v.latitude && v.longitude
// //         )

// //         if (!weightMatched.length)
// //             throw new Error(`No vehicles found matching tonnage "${booking.tonnage}"`)


// //         const formatToApiTime = (dateStr) => {
// //             const d = new Date(dateStr)
// //             if (isNaN(d)) return null

// //             const pad = (n) => String(n).padStart(2, '0')

// //             return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
// //         }

// //         const startTime = formatToApiTime(booking.bsTime)
// //         const endTime   = formatToApiTime(booking.beTime)

// //         if (!startTime || !endTime)
// //             throw new Error('Invalid booking time format')

// //         const vehiclesWithDistance = weightMatched.map((v) => ({
// //             ...v,
// //             distanceKm: parseFloat(
// //                 haversineKm(
// //                     parseFloat(v.latitude),
// //                     parseFloat(v.longitude),
// //                     toLat,
// //                     toLon
// //                 ).toFixed(2)
// //             ),
// //         }))


// //         const availabilityChecks = await Promise.all(
// //             vehiclesWithDistance.map(async (v) => {
// //                 try {
// //                     const res = await AdminBookingRequestService.GetVehicleAlreadyInfo(
// //                         v.vehicleId,
// //                         startTime,
// //                         endTime
// //                     )

// //                     const isBusy =
// //                         String(res.data?.result || '').toLowerCase() === 'true'

// //                     console.log(
// //                         `[CHECK] ${v.vehicleId} →`,
// //                         isBusy ? 'BUSY ❌' : 'FREE ✅'
// //                     )

// //                     return {
// //                         ...v,
// //                         isAvailable: !isBusy,
// //                     }
// //                 } catch (err) {
// //                     console.error('Conflict check failed:', v.vehicleId)
// //                     return {
// //                         ...v,
// //                         isAvailable: true
// //                     }
// //                 }
// //             })
// //         )

// //         const availableVehicles = availabilityChecks.filter(v => v.isAvailable)

// //         if (!availableVehicles.length)
// //             throw new Error('No available vehicles in selected time slot')


// //         const ranked = availableVehicles.sort((a, b) => a.distanceKm - b.distanceKm)

// //         const nearest = ranked[0]

// //         dispatch({
// //             type: ADMIN_FIND_NEAREST_DRIVER_SUCCESS,
// //             payload: { nearest, ranked }
// //         })

// //         return { nearest, ranked }

// //     } catch (error) {
// //         console.error('[AdminFindNearest]', error.message)
// //         dispatch({
// //             type: ADMIN_FIND_NEAREST_DRIVER_FAIL,
// //             payload: error.message
// //         })
// //         throw error
// //     }
// // }

// // // ─── Check if selected vehicle is already assigned in this time slot ──────────
// // // Returns true  = conflicted (vehicle is busy → admin must change times)
// // // Returns false = free (safe to proceed)
// // export const AdminCheckVehicleConflict = (vehicleId, bookingId, startTime, endTime) => async (dispatch) => {
// //     dispatch({ type: ADMIN_CHECK_CONFLICT_REQUEST })
// //     try {
// //         const res  = await AdminBookingRequestService.GetVehicleAlreadyInfo(vehicleId, bookingId, startTime, endTime)
// //         const data = res.data?.resultSet || res.data

// //         // API returns a result indicating whether the vehicle is already assigned.
// //         // Treat any truthy / non-empty result as conflicted.
// //         const isConflicted = Array.isArray(data) ? data.length > 0 : Boolean(data)

// //         console.log('[AdminCheckConflict] vehicle:', vehicleId, '| conflicted:', isConflicted, '| raw:', data)
// //         dispatch({ type: ADMIN_CHECK_CONFLICT_SUCCESS, payload: isConflicted })
// //         return isConflicted

// //     } catch (error) {
// //         console.error('[AdminCheckConflict]', error.message)
// //         dispatch({ type: ADMIN_CHECK_CONFLICT_FAIL, payload: error?.response?.data?.message || error.message })
// //         // On API error treat as not conflicted so admin can still proceed
// //         return false
// //     }
// // }
 
// // export const AdminAcceptBooking = (booking, selectedVehicle, authKey, overrideTimes = null) => async (dispatch) => {
// //     dispatch({ type: ADMIN_ACCEPT_BOOKING_REQUEST })
// //     try {
// //         const payload = [{
// //             bId:           booking.bId && booking.bId !== '0' ? booking.bId : '',
// //             vId:           selectedVehicle.vehicleId,
// //             dSNo:          selectedVehicle.driverSno,
// //             reqId:         booking.reqId,
// //             slatitude:     booking.slatitude,
// //             slongitude:    booking.slongitude,
// //             elatitude:     booking.elatitude,
// //             elongitude:    booking.elongitude,
// //             dlatitude:     booking.dlatitude  || booking.slatitude,
// //             dlongitude:    booking.dlongitude || booking.slongitude,
// //             status:        'P',
// //             bookingDT:     booking.bookingDT,
// //             // Use admin-overridden times if provided, otherwise original booking times
// //             bsTime:        overrideTimes ? overrideTimes.bsTime : booking.bsTime,
// //             beTime:        overrideTimes ? overrideTimes.beTime : booking.beTime,
// //             totalDestence: booking.totalDestence || '0',
// //             bookingSno:    booking.bookingSno,
// //             WorkArea:      booking.WorkArea  || null,
// //             WorkScope:     booking.WorkScope || null,
// //             Priority:      booking.Priority  || null,
// //             From:          booking.From      || '',
// //             TO:            booking.TO        || '',
// //             Remark:        booking.Remark    || '',
// //             SubBook:       booking.SubBook   || '',
// //             BookingStatus: 'S',
// //         }]

// //         // Only persist to DB — driver's pollScheduled() triggers popup at bsTime
// //         await AdminBookingRequestService.PostForkBooking(payload)

// //         dispatch({ type: ADMIN_ACCEPT_BOOKING_SUCCESS })
// //         return true

// //     } catch (error) {
// //         console.error('[AdminAcceptBooking]', error.message)
// //         dispatch({ type: ADMIN_ACCEPT_BOOKING_FAIL, payload: error?.response?.data?.message || error.message })
// //         throw error
// //     }
// // }



// // export const ResetAdminBookingRequest = () => (dispatch) => {
// //     dispatch({ type: RESET_ADMIN_BOOKING_REQUEST })
// // }


















// import {
//     FETCH_BOOKING_REQUESTS_REQUEST,
//     FETCH_BOOKING_REQUESTS_SUCCESS,
//     FETCH_BOOKING_REQUESTS_FAIL,
//     SET_ACCEPTED_REQIDS,
//     ADMIN_FIND_NEAREST_DRIVER_REQUEST,
//     ADMIN_FIND_NEAREST_DRIVER_SUCCESS,
//     ADMIN_FIND_NEAREST_DRIVER_FAIL,
//     ADMIN_ACCEPT_BOOKING_REQUEST,
//     ADMIN_ACCEPT_BOOKING_SUCCESS,
//     ADMIN_ACCEPT_BOOKING_FAIL,
//     ADMIN_CHECK_CONFLICT_REQUEST,
//     ADMIN_CHECK_CONFLICT_SUCCESS,
//     ADMIN_CHECK_CONFLICT_FAIL,
//     RESET_ADMIN_BOOKING_REQUEST,
//     ADMIN_CANCEL_BOOKING_REQUEST,
//     ADMIN_CANCEL_BOOKING_SUCCESS,
//     ADMIN_CANCEL_BOOKING_FAIL,
// } from '../constants/AdminBookingRequestConstants'

// import AdminBookingRequestService from '../services/AdminBookingRequestService'

// // ─── haversine (same as ScheduleBookingAction) ────────────────────────────────
// const haversineKm = (lat1, lon1, lat2, lon2) => {
//     const R = 6371
//     const toRad = (v) => (v * Math.PI) / 180
//     const dLat = toRad(lat2 - lat1)
//     const dLon = toRad(lon2 - lon1)
//     const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2
//     return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
// }

// // ─── Helper: Map SubBooking display text to API code ──────────────────────────
// // Converts database SubBooking values (T, TC, C) to display names
// const getSubBookingValue = (subBooking) => {
//     if (!subBooking) return ''
    
//     const value = String(subBooking).trim().toUpperCase()
    
//     switch (value) {
//         case 'TRAILER':
//             return 'T'
//         case 'TRAILER AND CRANE':
//             return 'TC'
//         case 'CRANE':
//             return 'C'
//         case 'T':
//         case 'TC':
//         case 'C':
//             return value  // Already in API format
//         default:
//             return ''
//     }
// }

// // ─── Helper: Map SubBooking code to display text ──────────────────────────────
// // Converts API codes (T, TC, C) to human-readable display names
// const getSubBookingDisplay = (subBooking) => {
//     if (!subBooking) return ''
    
//     const value = String(subBooking).trim().toUpperCase()
    
//     switch (value) {
//         case 'T':
//             return 'Trailer'
//         case 'TC':
//             return 'Trailer And Crane'
//         case 'C':
//             return 'Crane'
//         default:
//             return value
//     }
// }

// // ─── Fetch all pending schedule booking requests ──────────────────────────────
// export const FetchBookingRequests = () => async (dispatch) => {
//     dispatch({ type: FETCH_BOOKING_REQUESTS_REQUEST })
//     try {
//         // fetch both APIs in parallel
//         const [reqRes, mainRes] = await Promise.all([
//             AdminBookingRequestService.GetBookingRequestDetails(),
//             AdminBookingRequestService.GetMainForkBookingDetails(),
//         ])

//         const list = Array.isArray(reqRes.data?.resultSet || reqRes.data)
//             ? (reqRes.data?.resultSet || reqRes.data)
//             : []

//         // collect all reqIds that exist in GetMainForkBookingDetails
//         // if a booking's reqId appears here it means admin already accepted it
//         const mainBookings = mainRes.data?.resultSet || mainRes.data || []
//         const acceptedReqIds = (Array.isArray(mainBookings) ? mainBookings : [])
//             .map(b => String(b.reqId || b.ReqId || ''))
//             .filter(id => id && id !== '0')

//         dispatch({ type: FETCH_BOOKING_REQUESTS_SUCCESS, payload: list })
//         dispatch({ type: SET_ACCEPTED_REQIDS, payload: acceptedReqIds })

//         return list
//     } catch (error) {
//         dispatch({ type: FETCH_BOOKING_REQUESTS_FAIL, payload: error?.response?.data?.message || error.message })
//         throw error
//     }
// }

// // ─── Find nearest + AVAILABLE vehicle ─────────────────────────────────────
// export const AdminFindNearestDriver = (booking) => async (dispatch) => {
//     dispatch({ type: ADMIN_FIND_NEAREST_DRIVER_REQUEST })
//     try {
//         const vRes     = await AdminBookingRequestService.GetRequestVehicleDetails()
//         const vehicles = vRes.data?.resultSet || vRes.data || []

//         if (!Array.isArray(vehicles) || !vehicles.length)
//             throw new Error('No vehicles returned from GetRequestVehicleDetails')

//         const toLat = parseFloat(booking.elatitude)
//         const toLon = parseFloat(booking.elongitude)

//         if (isNaN(toLat) || isNaN(toLon))
//             throw new Error(`Booking ${booking.reqId} has no valid location`)

//         const bookingTonnage = String(booking.tonnage || '').trim().toUpperCase()

//         const weightMatched = vehicles.filter((v) =>
//             String(v.weightCat || '').trim().toUpperCase() === bookingTonnage &&
//             v.driverSno && v.latitude && v.longitude
//         )

//         if (!weightMatched.length)
//             throw new Error(`No vehicles found matching tonnage "${booking.tonnage}"`)


//         const formatToApiTime = (dateStr) => {
//             const d = new Date(dateStr)
//             if (isNaN(d)) return null

//             const pad = (n) => String(n).padStart(2, '0')

//             return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
//         }

//         const startTime = formatToApiTime(booking.bsTime)
//         const endTime   = formatToApiTime(booking.beTime)

//         if (!startTime || !endTime)
//             throw new Error('Invalid booking time format')

//         const vehiclesWithDistance = weightMatched.map((v) => ({
//             ...v,
//             distanceKm: parseFloat(
//                 haversineKm(
//                     parseFloat(v.latitude),
//                     parseFloat(v.longitude),
//                     toLat,
//                     toLon
//                 ).toFixed(2)
//             ),
//         }))


//         const availabilityChecks = await Promise.all(
//             vehiclesWithDistance.map(async (v) => {
//                 try {
//                     const res = await AdminBookingRequestService.GetVehicleAlreadyInfo(
//                         v.vehicleId,
//                         startTime,
//                         endTime
//                     )

//                     const isBusy =
//                         String(res.data?.result || '').toLowerCase() === 'true'

//                     console.log(
//                         `[CHECK] ${v.vehicleId} →`,
//                         isBusy ? 'BUSY ❌' : 'FREE ✅'
//                     )

//                     return {
//                         ...v,
//                         isAvailable: !isBusy,
//                     }
//                 } catch (err) {
//                     console.error('Conflict check failed:', v.vehicleId)
//                     return {
//                         ...v,
//                         isAvailable: true
//                     }
//                 }
//             })
//         )

//         const availableVehicles = availabilityChecks.filter(v => v.isAvailable)

//         if (!availableVehicles.length)
//             throw new Error('No available vehicles in selected time slot')


//         const ranked = availableVehicles.sort((a, b) => a.distanceKm - b.distanceKm)

//         const nearest = ranked[0]

//         dispatch({
//             type: ADMIN_FIND_NEAREST_DRIVER_SUCCESS,
//             payload: { nearest, ranked }
//         })

//         return { nearest, ranked }

//     } catch (error) {
//         console.error('[AdminFindNearest]', error.message)
//         dispatch({
//             type: ADMIN_FIND_NEAREST_DRIVER_FAIL,
//             payload: error.message
//         })
//         throw error
//     }
// }

// // ─── Check if selected vehicle is already assigned in this time slot ──────────
// // Returns true  = conflicted (vehicle is busy → admin must change times)
// // Returns false = free (safe to proceed)
// export const AdminCheckVehicleConflict = (vehicleId, bookingId, startTime, endTime) => async (dispatch) => {
//     dispatch({ type: ADMIN_CHECK_CONFLICT_REQUEST })
//     try {
//         const res  = await AdminBookingRequestService.GetVehicleAlreadyInfo(vehicleId, bookingId, startTime, endTime)
//         const data = res.data?.resultSet || res.data

//         // API returns a result indicating whether the vehicle is already assigned.
//         // Treat any truthy / non-empty result as conflicted.
//         const isConflicted = Array.isArray(data) ? data.length > 0 : Boolean(data)

//         console.log('[AdminCheckConflict] vehicle:', vehicleId, '| conflicted:', isConflicted, '| raw:', data)
//         dispatch({ type: ADMIN_CHECK_CONFLICT_SUCCESS, payload: isConflicted })
//         return isConflicted

//     } catch (error) {
//         console.error('[AdminCheckConflict]', error.message)
//         dispatch({ type: ADMIN_CHECK_CONFLICT_FAIL, payload: error?.response?.data?.message || error.message })
//         // On API error treat as not conflicted so admin can still proceed
//         return false
//     }
// }

// // ─── Admin accepts booking → posts to PostForkBooking ────────────────────────── 
// export const AdminAcceptBooking = (booking, selectedVehicle, authKey, overrideTimes = null) => async (dispatch) => {
//     dispatch({ type: ADMIN_ACCEPT_BOOKING_REQUEST })
//     try { 
//         const subBookingCode = getSubBookingValue(booking.SubBook)

//         const payload = [{
//             bId:           booking.bId && booking.bId !== '0' ? booking.bId : '',
//             vId:           selectedVehicle.vehicleId,
//             dSNo:          selectedVehicle.driverSno,
//             reqId:         booking.reqId,
//             slatitude:     booking.slatitude,
//             slongitude:    booking.slongitude,
//             elatitude:     booking.elatitude,
//             elongitude:    booking.elongitude,
//             dlatitude:     booking.dlatitude  || booking.slatitude,
//             dlongitude:    booking.dlongitude || booking.slongitude,
//             status:        'P',
//             bookingDT:     booking.bookingDT, 
//             bsTime:        overrideTimes ? overrideTimes.bsTime : booking.bsTime,
//             beTime:        overrideTimes ? overrideTimes.beTime : booking.beTime,
//             totalDestence: booking.totalDestence || '0',
//             bookingSno:    booking.bookingSno,
//             WorkArea:      booking.WorkArea  || null,
//             WorkScope:     booking.WorkScope || null,
//             Priority:      booking.Priority  || null,
//             From:          booking.From      || '',
//             TO:            booking.TO        || '',
//             Remark:        booking.Remark    || '', 
//             SubBook:       subBookingCode,
//             BookingStatus: 'S',
//         }]

//         console.log('[AdminAcceptBooking] SubBook conversion:', {
//             input: booking.SubBook,
//             output: subBookingCode
//         })
 
//         await AdminBookingRequestService.PostForkBooking(payload)

//         dispatch({ type: ADMIN_ACCEPT_BOOKING_SUCCESS })
//         return true

//     } catch (error) {
//         console.error('[AdminAcceptBooking]', error.message)
//         dispatch({ type: ADMIN_ACCEPT_BOOKING_FAIL, payload: error?.response?.data?.message || error.message })
//         throw error
//     }
// }

// // Cancel booking request
// export const AdminCancelBooking = (reqId) => async (dispatch) => {
//   dispatch({ type: ADMIN_CANCEL_BOOKING_REQUEST })
  
//   try {
//     // Call the cancel API with status "C"
//     await AdminBookingRequestService.PostBookingRequestStatus(reqId)
    
//     dispatch({
//       type: ADMIN_CANCEL_BOOKING_SUCCESS,
//       payload: reqId,
//     })
    
//     // Refresh booking list after cancellation
//     dispatch(FetchBookingRequests())
    
//     return { success: true }
//   } catch (error) {
//     const message = error?.response?.data?.message || error?.message || 'Failed to cancel booking'
//     dispatch({
//       type: ADMIN_CANCEL_BOOKING_FAIL,
//       payload: message,
//     })
//     throw error
//   }
// }

// export const ResetAdminBookingRequest = () => (dispatch) => {
//     dispatch({ type: RESET_ADMIN_BOOKING_REQUEST })
// }

// // ─── EXPORT UTILITIES ──────────────────────────────────────────────────────── 
// export { getSubBookingValue, getSubBookingDisplay }
// //-------------------------------------All driver assign vehicle display-------------------------------------
// import {
//     FETCH_BOOKING_REQUESTS_REQUEST,
//     FETCH_BOOKING_REQUESTS_SUCCESS,
//     FETCH_BOOKING_REQUESTS_FAIL,
//     ADMIN_FIND_NEAREST_DRIVER_REQUEST,
//     ADMIN_FIND_NEAREST_DRIVER_SUCCESS,
//     ADMIN_FIND_NEAREST_DRIVER_FAIL,
//     ADMIN_ACCEPT_BOOKING_REQUEST,
//     ADMIN_ACCEPT_BOOKING_SUCCESS,
//     ADMIN_ACCEPT_BOOKING_FAIL,
//     ADMIN_CHECK_CONFLICT_REQUEST,
//     ADMIN_CHECK_CONFLICT_SUCCESS,
//     ADMIN_CHECK_CONFLICT_FAIL,
//     RESET_ADMIN_BOOKING_REQUEST,
// } from '../constants/AdminBookingRequestConstants'

// import AdminBookingRequestService from '../services/AdminBookingRequestService'

// // ─── haversine (same as ScheduleBookingAction) ────────────────────────────────
// const haversineKm = (lat1, lon1, lat2, lon2) => {
//     const R = 6371
//     const toRad = (v) => (v * Math.PI) / 180
//     const dLat = toRad(lat2 - lat1)
//     const dLon = toRad(lon2 - lon1)
//     const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2
//     return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
// }

// // ─── Fetch all pending schedule booking requests ──────────────────────────────
// export const FetchBookingRequests = () => async (dispatch) => {
//     dispatch({ type: FETCH_BOOKING_REQUESTS_REQUEST })
//     try {
//         const res  = await AdminBookingRequestService.GetBookingRequestDetails()
//         const data = res.data?.resultSet || res.data || []
//         const list = Array.isArray(data) ? data : []
//         dispatch({ type: FETCH_BOOKING_REQUESTS_SUCCESS, payload: list })
//         return list
//     } catch (error) {
//         dispatch({ type: FETCH_BOOKING_REQUESTS_FAIL, payload: error?.response?.data?.message || error.message })
//         throw error
//     }
// }

// // ─── Find nearest + AVAILABLE vehicle ─────────────────────────────────────
// export const AdminFindNearestDriver = (booking) => async (dispatch) => {
//     dispatch({ type: ADMIN_FIND_NEAREST_DRIVER_REQUEST })
//     try {
//         const vRes     = await AdminBookingRequestService.GetRequestVehicleDetails()
//         const vehicles = vRes.data?.resultSet || vRes.data || []

//         if (!Array.isArray(vehicles) || !vehicles.length)
//             throw new Error('No vehicles returned from GetRequestVehicleDetails')

//         const toLat = parseFloat(booking.elatitude)
//         const toLon = parseFloat(booking.elongitude)

//         if (isNaN(toLat) || isNaN(toLon))
//             throw new Error(`Booking ${booking.reqId} has no valid location`)

//         const bookingTonnage = String(booking.tonnage || '').trim().toUpperCase()

//         const weightMatched = vehicles.filter((v) =>
//             String(v.weightCat || '').trim().toUpperCase() === bookingTonnage &&
//             v.driverSno && v.latitude && v.longitude
//         )

//         if (!weightMatched.length)
//             throw new Error(`No vehicles found matching tonnage "${booking.tonnage}"`)


//         const formatToApiTime = (dateStr) => {
//             const d = new Date(dateStr)
//             if (isNaN(d)) return null

//             const pad = (n) => String(n).padStart(2, '0')

//             return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
//         }

//         const startTime = formatToApiTime(booking.bsTime)
//         const endTime   = formatToApiTime(booking.beTime)

//         if (!startTime || !endTime)
//             throw new Error('Invalid booking time format')

//         const vehiclesWithDistance = weightMatched.map((v) => ({
//             ...v,
//             distanceKm: parseFloat(
//                 haversineKm(
//                     parseFloat(v.latitude),
//                     parseFloat(v.longitude),
//                     toLat,
//                     toLon
//                 ).toFixed(2)
//             ),
//         }))


//         const availabilityChecks = await Promise.all(
//             vehiclesWithDistance.map(async (v) => {
//                 try {
//                     const res = await AdminBookingRequestService.GetVehicleAlreadyInfo(
//                         v.vehicleId,
//                         startTime,
//                         endTime
//                     )

//                     const isBusy =
//                         String(res.data?.result || '').toLowerCase() === 'true'

//                     console.log(
//                         `[CHECK] ${v.vehicleId} →`,
//                         isBusy ? 'BUSY ❌' : 'FREE ✅'
//                     )

//                     return {
//                         ...v,
//                         isAvailable: !isBusy,
//                     }
//                 } catch (err) {
//                     console.error('Conflict check failed:', v.vehicleId)
//                     return {
//                         ...v,
//                         isAvailable: true
//                     }
//                 }
//             })
//         )

//         const availableVehicles = availabilityChecks.filter(v => v.isAvailable)

//         if (!availableVehicles.length)
//             throw new Error('No available vehicles in selected time slot')


//         const ranked = availableVehicles.sort((a, b) => a.distanceKm - b.distanceKm)

//         const nearest = ranked[0]

//         dispatch({
//             type: ADMIN_FIND_NEAREST_DRIVER_SUCCESS,
//             payload: { nearest, ranked }
//         })

//         return { nearest, ranked }

//     } catch (error) {
//         console.error('[AdminFindNearest]', error.message)
//         dispatch({
//             type: ADMIN_FIND_NEAREST_DRIVER_FAIL,
//             payload: error.message
//         })
//         throw error
//     }
// }

// // ─── Check if selected vehicle is already assigned in this time slot ──────────
// // Returns true  = conflicted (vehicle is busy → admin must change times)
// // Returns false = free (safe to proceed)
// export const AdminCheckVehicleConflict = (vehicleId, bookingId, startTime, endTime) => async (dispatch) => {
//     dispatch({ type: ADMIN_CHECK_CONFLICT_REQUEST })
//     try {
//         const res  = await AdminBookingRequestService.GetVehicleAlreadyInfo(vehicleId, bookingId, startTime, endTime)
//         const data = res.data?.resultSet || res.data

//         // API returns a result indicating whether the vehicle is already assigned.
//         // Treat any truthy / non-empty result as conflicted.
//         const isConflicted = Array.isArray(data) ? data.length > 0 : Boolean(data)

//         console.log('[AdminCheckConflict] vehicle:', vehicleId, '| conflicted:', isConflicted, '| raw:', data)
//         dispatch({ type: ADMIN_CHECK_CONFLICT_SUCCESS, payload: isConflicted })
//         return isConflicted

//     } catch (error) {
//         console.error('[AdminCheckConflict]', error.message)
//         dispatch({ type: ADMIN_CHECK_CONFLICT_FAIL, payload: error?.response?.data?.message || error.message })
//         // On API error treat as not conflicted so admin can still proceed
//         return false
//     }
// }
 
// export const AdminAcceptBooking = (booking, selectedVehicle, authKey, overrideTimes = null) => async (dispatch) => {
//     dispatch({ type: ADMIN_ACCEPT_BOOKING_REQUEST })
//     try {
//         const payload = [{
//             bId:           booking.bId && booking.bId !== '0' ? booking.bId : '',
//             vId:           selectedVehicle.vehicleId,
//             dSNo:          selectedVehicle.driverSno,
//             reqId:         booking.reqId,
//             slatitude:     booking.slatitude,
//             slongitude:    booking.slongitude,
//             elatitude:     booking.elatitude,
//             elongitude:    booking.elongitude,
//             dlatitude:     booking.dlatitude  || booking.slatitude,
//             dlongitude:    booking.dlongitude || booking.slongitude,
//             status:        'P',
//             bookingDT:     booking.bookingDT,
//             // Use admin-overridden times if provided, otherwise original booking times
//             bsTime:        overrideTimes ? overrideTimes.bsTime : booking.bsTime,
//             beTime:        overrideTimes ? overrideTimes.beTime : booking.beTime,
//             totalDestence: booking.totalDestence || '0',
//             bookingSno:    booking.bookingSno,
//             WorkArea:      booking.WorkArea  || null,
//             WorkScope:     booking.WorkScope || null,
//             Priority:      booking.Priority  || null,
//             From:          booking.From      || '',
//             TO:            booking.TO        || '',
//             Remark:        booking.Remark    || '',
//             SubBook:       booking.SubBook   || '',
//             BookingStatus: 'S',
//         }]

//         // Only persist to DB — driver's pollScheduled() triggers popup at bsTime
//         await AdminBookingRequestService.PostForkBooking(payload)

//         dispatch({ type: ADMIN_ACCEPT_BOOKING_SUCCESS })
//         return true

//     } catch (error) {
//         console.error('[AdminAcceptBooking]', error.message)
//         dispatch({ type: ADMIN_ACCEPT_BOOKING_FAIL, payload: error?.response?.data?.message || error.message })
//         throw error
//     }
// }



// export const ResetAdminBookingRequest = () => (dispatch) => {
//     dispatch({ type: RESET_ADMIN_BOOKING_REQUEST })
// }


















import {
    FETCH_BOOKING_REQUESTS_REQUEST,
    FETCH_BOOKING_REQUESTS_SUCCESS,
    FETCH_BOOKING_REQUESTS_FAIL,
    SET_ACCEPTED_REQIDS,
    ADMIN_FIND_NEAREST_DRIVER_REQUEST,
    ADMIN_FIND_NEAREST_DRIVER_SUCCESS,
    ADMIN_FIND_NEAREST_DRIVER_FAIL,
    ADMIN_ACCEPT_BOOKING_REQUEST,
    ADMIN_ACCEPT_BOOKING_SUCCESS,
    ADMIN_ACCEPT_BOOKING_FAIL,
    ADMIN_CHECK_CONFLICT_REQUEST,
    ADMIN_CHECK_CONFLICT_SUCCESS,
    ADMIN_CHECK_CONFLICT_FAIL,
    RESET_ADMIN_BOOKING_REQUEST,
    ADMIN_CANCEL_BOOKING_REQUEST,
    ADMIN_CANCEL_BOOKING_SUCCESS,
    ADMIN_CANCEL_BOOKING_FAIL,
} from '../constants/AdminBookingRequestConstants'

import AdminBookingRequestService from '../services/AdminBookingRequestService'

// ─── haversine (same as ScheduleBookingAction) ────────────────────────────────
const haversineKm = (lat1, lon1, lat2, lon2) => {
    const R = 6371
    const toRad = (v) => (v * Math.PI) / 180
    const dLat = toRad(lat2 - lat1)
    const dLon = toRad(lon2 - lon1)
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) ** 2
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
}

// ─── Helper: Map SubBooking display text to API code ──────────────────────────
// Converts database SubBooking values (T, TC, C) to display names
const getSubBookingValue = (subBooking) => {
    if (!subBooking) return ''
    
    const value = String(subBooking).trim().toUpperCase()
    
    switch (value) {
        case 'TRAILER':
            return 'T'
        case 'TRAILER AND CRANE':
            return 'TC'
        case 'CRANE':
            return 'C'
        case 'T':
        case 'TC':
        case 'C':
            return value  // Already in API format
        default:
            return ''
    }
}

// ─── Helper: Map SubBooking code to display text ──────────────────────────────
// Converts API codes (T, TC, C) to human-readable display names
const getSubBookingDisplay = (subBooking) => {
    if (!subBooking) return ''
    
    const value = String(subBooking).trim().toUpperCase()
    
    switch (value) {
        case 'T':
            return 'Trailer'
        case 'TC':
            return 'Trailer And Crane'
        case 'C':
            return 'Crane'
        default:
            return value
    }
}

// ─── Fetch all pending schedule booking requests ──────────────────────────────
export const FetchBookingRequests = () => async (dispatch) => {
    dispatch({ type: FETCH_BOOKING_REQUESTS_REQUEST })
    try {
        // fetch both APIs in parallel
        const [reqRes, mainRes] = await Promise.all([
            AdminBookingRequestService.GetBookingRequestDetails(),
            AdminBookingRequestService.GetMainForkBookingDetails(),
        ])

        const list = Array.isArray(reqRes.data?.resultSet || reqRes.data)
            ? (reqRes.data?.resultSet || reqRes.data)
            : []

        // collect all reqIds that exist in GetMainForkBookingDetails
        // if a booking's reqId appears here it means admin already accepted it
        const mainBookings = mainRes.data?.resultSet || mainRes.data || []
        const acceptedReqIds = (Array.isArray(mainBookings) ? mainBookings : [])
            .map(b => String(b.reqId || b.ReqId || ''))
            .filter(id => id && id !== '0')

        dispatch({ type: FETCH_BOOKING_REQUESTS_SUCCESS, payload: list })
        dispatch({ type: SET_ACCEPTED_REQIDS, payload: acceptedReqIds })

        return list
    } catch (error) {
        dispatch({ type: FETCH_BOOKING_REQUESTS_FAIL, payload: error?.response?.data?.message || error.message })
        throw error
    }
}

// ─── Format date to API time string ──────────────────────────────────────────
const formatToApiTime = (d) => {
    const date = d instanceof Date ? d : new Date(d)
    if (!date || isNaN(date.getTime())) return null
    const pad = (n) => String(n).padStart(2, '0')
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`
}

// ─── Find best vehicle using smart job-end proximity logic ────────────────────
//
// PRIORITY ORDER (same for both scheduled & unplanned bookings):
//
//   STEP 1 — "Job-ending-nearby" candidate
//     • Find all same-tonnage vehicles whose current active job ends within
//       30 minutes of the NEW booking's start time.
//     • Among those, only keep vehicles whose current job's END LOCATION
//       is near the NEW booking's START LOCATION (measured by haversine distance
//       from active job elatitude/elongitude → new booking slatitude/slongitude).
//     • Sort by that distance (closest end-location to new start-location first).
//     • Pick the best one.
//
//   STEP 2 — Fallback (no qualifying job-ending vehicle found)
//     • Among all free/available same-tonnage vehicles, pick the one whose
//       current GPS location is nearest to the new booking's START location.
//
// Example:
//   New booking starts at 10:00, start location = Dock A
//   Vehicle A: free, parked 5 km from Dock A
//   Vehicle B: job ends 10:20 (within 30 min), job end location 0.5 km from Dock A  ← STEP 1 WINNER
//   Vehicle C: job ends 11:00 (>30 min) → skipped
//   → Vehicle B is picked because it finishes nearby and is available just in time.
//
export const AdminFindNearestDriver = (booking) => async (dispatch) => {
    dispatch({ type: ADMIN_FIND_NEAREST_DRIVER_REQUEST })
    try {
        // ── 1. Fetch vehicles + active fork bookings in parallel ──────────────
        const [vRes, mainRes] = await Promise.all([
            AdminBookingRequestService.GetRequestVehicleDetails(),
            AdminBookingRequestService.GetMainForkBookingDetails(),
        ])

        const vehicles = vRes.data?.resultSet || vRes.data || []
        if (!Array.isArray(vehicles) || !vehicles.length)
            throw new Error('No vehicles returned from GetRequestVehicleDetails')

        // GetMainForkBookingDetails = all currently active/assigned fork bookings.
        // Each entry has: vId, beTime (job end time), elatitude, elongitude (job end location)
        const activeJobs = Array.isArray(mainRes.data?.resultSet || mainRes.data)
            ? (mainRes.data?.resultSet || mainRes.data)
            : []

        // ── 2. Parse new booking times & locations ────────────────────────────
        const newStart = new Date(booking.bsTime)
        const newEnd   = new Date(booking.beTime)
        if (isNaN(newStart.getTime()) || isNaN(newEnd.getTime()))
            throw new Error('Invalid booking time format')

        // New booking START location — this is where the vehicle needs to arrive
        const newStartLat = parseFloat(booking.slatitude)
        const newStartLon = parseFloat(booking.slongitude)
        if (isNaN(newStartLat) || isNaN(newStartLon))
            throw new Error(`Booking ${booking.reqId || booking.bId} has no valid start location`)

        const bookingTonnage = String(booking.tonnage || '').trim().toUpperCase()

        // ── 3. Filter by tonnage + must have driver and GPS ───────────────────
        const weightMatched = vehicles.filter((v) =>
            String(v.weightCat || '').trim().toUpperCase() === bookingTonnage &&
            v.driverSno && v.latitude && v.longitude
        )
        if (!weightMatched.length)
            throw new Error(`No vehicles found matching tonnage "${booking.tonnage}"`)

        const newStartStr = formatToApiTime(newStart)
        const newEndStr   = formatToApiTime(newEnd)
        if (!newStartStr || !newEndStr)
            throw new Error('Could not format booking times for API')

        // ── 4. Build vehicleId → best active job map ──────────────────────────
        // For each vehicle that has an active job, record:
        //   jobEndTime    — when the job finishes
        //   jobEndLat/Lon — where the vehicle will be when it finishes
        //
        // "Active" means the job hasn't ended yet (beTime is in the future).
        // If a vehicle has multiple active jobs we take the one ending soonest.
        const now = new Date()
        const vehicleJobMap = {}  // vehicleId (string) → { jobEndTime, jobEndLat, jobEndLon }

        activeJobs.forEach((job) => {
            const vid    = String(job.vId || job.vehicleId || '').trim()
            const beRaw  = job.beTime || job.BeTime || job.endTime
            if (!vid || !beRaw) return

            const jobEndTime = new Date(beRaw)
            if (isNaN(jobEndTime.getTime())) return
            if (jobEndTime <= now) return  // already finished — irrelevant

            const jobEndLat = parseFloat(job.elatitude || job.Elatitude || 0)
            const jobEndLon = parseFloat(job.elongitude || job.Elongitude || 0)

            // keep soonest-ending job per vehicle
            if (!vehicleJobMap[vid] || jobEndTime < vehicleJobMap[vid].jobEndTime) {
                vehicleJobMap[vid] = { jobEndTime, jobEndLat, jobEndLon }
            }
        })

        // ── 5. Availability check + build enriched vehicle objects ─────────────
        const checkedVehicles = await Promise.all(
            weightMatched.map(async (v) => {
                let isBusy = false
                try {
                    const res = await AdminBookingRequestService.GetVehicleAlreadyInfo(
                        v.vehicleId,
                        newStartStr,
                        newEndStr
                    )
                    isBusy = String(res.data?.result || '').toLowerCase() === 'true'
                    console.log(`[CHECK] ${v.vehicleId} →`, isBusy ? 'BUSY ❌' : 'FREE ✅')
                } catch (err) {
                    console.error('[CHECK] failed for', v.vehicleId, err.message)
                    // assume free on API error — don't silently block all vehicles
                }

                const activeJob = vehicleJobMap[String(v.vehicleId)] || null

                // minutesUntilFree: how many minutes between job end and new booking start
                // negative = job ends BEFORE new booking starts (vehicle will be free in time)
                // positive = job ends AFTER new booking starts (still busy at start time — but
                //            GetVehicleAlreadyInfo already accounts for this via isBusy)
                const minutesUntilFree = activeJob
                    ? (activeJob.jobEndTime.getTime() - newStart.getTime()) / 60000
                    : null

                // Distance from vehicle's current job END location → new booking START location
                // This is the most important distance: how far does the vehicle have to travel
                // from where it finishes to where the new job begins.
                const distFromJobEndToNewStart = (activeJob && !isNaN(activeJob.jobEndLat) && !isNaN(activeJob.jobEndLon))
                    ? parseFloat(haversineKm(
                        activeJob.jobEndLat,
                        activeJob.jobEndLon,
                        newStartLat,
                        newStartLon
                    ).toFixed(2))
                    : null

                // Distance from vehicle's CURRENT GPS location → new booking START location
                // Used as fallback when no active job exists
                const distFromCurrentToNewStart = parseFloat(haversineKm(
                    parseFloat(v.latitude),
                    parseFloat(v.longitude),
                    newStartLat,
                    newStartLon
                ).toFixed(2))

                return {
                    ...v,
                    isAvailable:              !isBusy,
                    activeJob,
                    minutesUntilFree,
                    distFromJobEndToNewStart,   // null if no active job
                    distFromCurrentToNewStart,  // always computed
                    // legacy field kept for UI display compatibility
                    distanceKm: distFromCurrentToNewStart,
                }
            })
        )

        // ── 6. STEP 1 — Job-ending-nearby candidate ───────────────────────────
        //
        // Conditions to qualify:
        //   a) Vehicle is available for the new time slot (GetVehicleAlreadyInfo = free)
        //   b) It has an active job ending within 30 min of new booking start
        //      i.e. minutesUntilFree is NOT null AND minutesUntilFree <= 30
        //      (includes negative values = job already ends before new booking starts)
        //   c) Its job end location is near the new booking's start location
        //      (we sort by distFromJobEndToNewStart ascending — closest wins)
        //
        const jobEndingCandidates = checkedVehicles.filter((v) =>
            v.isAvailable &&
            v.minutesUntilFree !== null &&
            v.minutesUntilFree <= 30 &&
            v.distFromJobEndToNewStart !== null
        )

        if (jobEndingCandidates.length > 0) {
            // Sort by how close the job end location is to the new booking start location
            jobEndingCandidates.sort((a, b) => a.distFromJobEndToNewStart - b.distFromJobEndToNewStart)

            const best = jobEndingCandidates[0]
            console.log(
                `[SUGGEST] STEP-1 ✅ Vehicle ${best.vehicleId}`,
                `| job ends in ${best.minutesUntilFree?.toFixed(1)} min`,
                `| job-end → new-start: ${best.distFromJobEndToNewStart} km`
            )

            dispatch({
                type: ADMIN_FIND_NEAREST_DRIVER_SUCCESS,
                payload: { nearest: best, ranked: [best] },
            })
            return { nearest: best, ranked: [best] }
        }

        // ── 7. STEP 2 — Fallback: nearest free vehicle by current GPS location ─
        console.log('[SUGGEST] No job-ending-within-30-min vehicle near new start. Falling back to nearest free vehicle.')

        const freeVehicles = checkedVehicles
            .filter((v) => v.isAvailable)
            .sort((a, b) => a.distFromCurrentToNewStart - b.distFromCurrentToNewStart)

        if (!freeVehicles.length)
            throw new Error('No available vehicles matching the required tonnage for this time slot')

        const best = freeVehicles[0]
        console.log(
            `[SUGGEST] STEP-2 fallback: Vehicle ${best.vehicleId}`,
            `| current GPS → new start: ${best.distFromCurrentToNewStart} km`
        )

        dispatch({
            type: ADMIN_FIND_NEAREST_DRIVER_SUCCESS,
            payload: { nearest: best, ranked: [best] },
        })
        return { nearest: best, ranked: [best] }

    } catch (error) {
        console.error('[AdminFindNearestDriver]', error.message)
        dispatch({
            type: ADMIN_FIND_NEAREST_DRIVER_FAIL,
            payload: error.message,
        })
        throw error
    }
}

// ─── Check if selected vehicle is already assigned in this time slot ──────────
// Returns true  = conflicted (vehicle is busy → admin must change times)
// Returns false = free (safe to proceed)
export const AdminCheckVehicleConflict = (vehicleId, bookingId, startTime, endTime) => async (dispatch) => {
    dispatch({ type: ADMIN_CHECK_CONFLICT_REQUEST })
    try {
        const res  = await AdminBookingRequestService.GetVehicleAlreadyInfo(vehicleId, bookingId, startTime, endTime)
        const data = res.data?.resultSet || res.data

        // API returns a result indicating whether the vehicle is already assigned.
        // Treat any truthy / non-empty result as conflicted.
        const isConflicted = Array.isArray(data) ? data.length > 0 : Boolean(data)

        console.log('[AdminCheckConflict] vehicle:', vehicleId, '| conflicted:', isConflicted, '| raw:', data)
        dispatch({ type: ADMIN_CHECK_CONFLICT_SUCCESS, payload: isConflicted })
        return isConflicted

    } catch (error) {
        console.error('[AdminCheckConflict]', error.message)
        dispatch({ type: ADMIN_CHECK_CONFLICT_FAIL, payload: error?.response?.data?.message || error.message })
        // On API error treat as not conflicted so admin can still proceed
        return false
    }
}

// ─── Admin accepts booking → posts to PostForkBooking ────────────────────────── 
export const AdminAcceptBooking = (booking, selectedVehicle, authKey, overrideTimes = null) => async (dispatch) => {
    dispatch({ type: ADMIN_ACCEPT_BOOKING_REQUEST })
    try { 
        const subBookingCode = getSubBookingValue(booking.SubBook)

        const payload = [{
            bId:           booking.bId && booking.bId !== '0' ? booking.bId : '',
            vId:           selectedVehicle.vehicleId,
            dSNo:          selectedVehicle.driverSno,
            reqId:         booking.reqId,
            slatitude:     booking.slatitude,
            slongitude:    booking.slongitude,
            elatitude:     booking.elatitude,
            elongitude:    booking.elongitude,
            dlatitude:     booking.dlatitude  || booking.slatitude,
            dlongitude:    booking.dlongitude || booking.slongitude,
            status:        'P',
            bookingDT:     booking.bookingDT, 
            bsTime:        overrideTimes ? overrideTimes.bsTime : booking.bsTime,
            beTime:        overrideTimes ? overrideTimes.beTime : booking.beTime,
            totalDestence: booking.totalDestence || '0',
            bookingSno:    booking.bookingSno,
            WorkArea:      booking.WorkArea  || null,
            WorkScope:     booking.WorkScope || null,
            Priority:      booking.Priority  || null,
            From:          booking.From      || '',
            TO:            booking.TO        || '',
            Remark:        booking.Remark    || '', 
            SubBook:       subBookingCode,
            BookingStatus: 'S',
        }]

        console.log('[AdminAcceptBooking] SubBook conversion:', {
            input: booking.SubBook,
            output: subBookingCode
        })
 
        await AdminBookingRequestService.PostForkBooking(payload)

        dispatch({ type: ADMIN_ACCEPT_BOOKING_SUCCESS })
        return true

    } catch (error) {
        console.error('[AdminAcceptBooking]', error.message)
        dispatch({ type: ADMIN_ACCEPT_BOOKING_FAIL, payload: error?.response?.data?.message || error.message })
        throw error
    }
}

// Cancel booking request
export const AdminCancelBooking = (reqId) => async (dispatch) => {
  dispatch({ type: ADMIN_CANCEL_BOOKING_REQUEST })
  
  try {
    // Call the cancel API with status "C"
    await AdminBookingRequestService.PostBookingRequestStatus(reqId)
    
    dispatch({
      type: ADMIN_CANCEL_BOOKING_SUCCESS,
      payload: reqId,
    })
    
    // Refresh booking list after cancellation
    dispatch(FetchBookingRequests())
    
    return { success: true }
  } catch (error) {
    const message = error?.response?.data?.message || error?.message || 'Failed to cancel booking'
    dispatch({
      type: ADMIN_CANCEL_BOOKING_FAIL,
      payload: message,
    })
    throw error
  }
}

export const ResetAdminBookingRequest = () => (dispatch) => {
    dispatch({ type: RESET_ADMIN_BOOKING_REQUEST })
}

// ─── EXPORT UTILITIES ──────────────────────────────────────────────────────── 
export { getSubBookingValue, getSubBookingDisplay }